<script lang="ts">
  import { xhr, toast } from "$app/utils"

  interface Props {
    symbol: SymbolType
    status: string
    onupdate: (plan: SymbolType) => void
    oncreate: (plan: SymbolType) => void
  }
  let { symbol, status = "", onupdate, oncreate }: Props = $props()

  let input: HTMLInputElement
  let file: any
  let showImage = $state(false)
  let image: any = $state(null)

  let form = $state({
    name: symbol.name,
    public_image: symbol.public_image
  }) as SymbolType

  let errors: any = $state({})
  let saving = $state(false)

  async function saveSymbol() {
    if (status === "edit") {
      await updateSymbol()
    } else {
      await createSymbol()
    }
  }

  function getFormData(): FormData {
    const formData = new FormData()
    formData.append("plan_symbol[name]", form.name || "")
    formData.append(
      "plan_symbol[public_image]",
      form.public_image == true ? "true" : "false"
    )
    if (showImage) {
      formData.append("plan_symbol[image]", file)
    }
    return formData
  }

  async function updateSymbol(): Promise<void> {
    try {
      saving = true
      const resp = await xhr.patch(
        `/admin/plan_symbols/${symbol.id}.json`,
        getFormData()
      )

      onupdate(resp.data)
    } catch (e) {
      console.error(e)
      errors = e.response.data.errors
    } finally {
      saving = false
    }
  }

  async function createSymbol(): Promise<void> {
    try {
      saving = true
      if (!showImage) {
        errors.image = "Invalid image"
        return
      }
      const resp = await xhr.post(`/admin/plan_symbols.json`, getFormData())

      toast("Symbol has been created", "success")
      oncreate(resp.data)
    } catch (e) {
      console.error(e)
      errors = e.response.data.errors
    } finally {
      saving = false
    }
  }

  function setForm(): void {
    form = {
      name: symbol.name,
      public_image: symbol.public_image
    } as SymbolType
  }

  function onChange(): void {
    file = input.files[0]

    if (file) {
      showImage = true

      const reader = new FileReader()
      reader.addEventListener("load", function () {
        image.setAttribute("src", reader.result)
      })
      reader.readAsDataURL(file)

      return
    }
    showImage = false
  }

  if (status) {
    setForm()
  }
</script>

<form>
  <h2 class="text-base font-semibold leading-6 text-gray-900">
    {status === "edit" ? "Edit" : "New"} Symbol
  </h2>

  <div class="grid grid-cols-2 gap-2">
    <div>
      {#if showImage}
        <img bind:this={image} src="" alt="Preview" />
      {:else if status === "edit"}
        <img src={symbol.image_url} alt={symbol.name} width="300" />
      {:else}
        <span class="text-gray-500">No Image</span>
      {/if}
      <div class="text-red-500">
        {errors.image || ""}
      </div>
    </div>
    <div>
      <input
        bind:this={input}
        onchange={onChange}
        type="file"
        accept=".jpg, .jpeg, .png, .webp"
      />
    </div>
  </div>

  <div class="input-cont">
    <label for="">Name</label>
    <input
      class="input-admin w-full input"
      type="text"
      bind:value={form.name}
    />
    <div class="text-red-500">
      {errors.name || ""}
    </div>
  </div>

  <div class="input-cont">
    <label for="public_image">
      <input
        class="input-admin"
        type="checkbox"
        id="public_image"
        bind:checked={form.public_image}
      />
      Public Image
    </label>
  </div>

  <div class="p-4 text-center">
    <button class="btn big primary" disabled={saving} onclick={saveSymbol}>
      {status === "edit" ? "Update" : "Create"}
    </button>
  </div>
</form>
